import { render, staticRenderFns } from "./YoDropdown.vue?vue&type=template&id=5ab70be2&scoped=true&"
import script from "./YoDropdown.vue?vue&type=script&lang=js&"
export * from "./YoDropdown.vue?vue&type=script&lang=js&"
import style0 from "./YoDropdown.vue?vue&type=style&index=0&id=5ab70be2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab70be2",
  null
  
)

export default component.exports